import { useEffect, useState } from "react";
import { Pagination, Spin, Empty, Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";

import TransactionCard from "../components/TransactionCard";
import TransactionDrawer from "../components/TransactionDrawer";

export default function TransactionHistory() {
  const [transactions, setTransactions] = useState([]);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [userId, setUserId] = useState(null);
  const [username, setUsername] = useState(null);

  const fetchTransactions = async (page = 1) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token || token === "undefined") {
        throw new Error("Token tidak tersedia. Silakan login ulang.");
      }

      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      // ✅ Ambil profil user
      const resUser = await axios.get("/api/auth/profile");
      const userId = resUser.data?.id;
      const username = resUser.data?.username;

      if (!userId && !username) {
        throw new Error("Data user tidak lengkap.");
      }

      setUserId(userId);
      setUsername(username);

      // ✅ Ambil transaksi berdasarkan user_id dan username
      const res = await axios.get("/api/transactions", {
        params: {
          page,
          user_id: userId,
          username: username,
        },
      });

      console.log("📦 Response transaksi:", res.data);

      const data = Array.isArray(res.data?.data)
        ? res.data.data
        : Array.isArray(res.data)
        ? res.data
        : [];

      setTransactions(data);
      setTotal(res.data?.total ?? data.length);
      setCurrentPage(res.data?.current_page ?? 1);
    } catch (err) {
      console.error("❌ Error transaksi:", err);
      setTransactions([]);
      Swal.fire({
        icon: "error",
        title: "Gagal ambil transaksi",
        text: err.response?.data?.message || err.message || "Silakan login ulang.",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleOpenDrawer = (tx) => {
    setSelectedTransaction(tx);
    setIsDrawerVisible(true);
  };

  useEffect(() => {
    fetchTransactions();
  }, []);

  return (
    <div className="bg-gray-100 min-h-screen pb-24">
      {/* 🔙 Header Navigasi */}
      <div className="p-4 border-b bg-white sticky top-0 z-10">
        <Link to="/AccountPage">
          <div className="flex items-center font-bold text-lg">
            <ArrowLeftOutlined className="text-gray-600" />
            <p className="ml-3 text-gray-600">Riwayat Transaksi</p>
          </div>
        </Link>
      </div>

      {/* 🧪 Debug Info */}
      <div className="px-4 py-2 text-xs text-gray-500">
        <p>🧑‍💼 User ID: {userId}</p>
        <p>👤 Username: {username}</p>
        <p>📦 Jumlah transaksi: {transactions.length}</p>
        <p>🔐 Token: {localStorage.getItem("token")?.slice(0, 20)}...</p>
        <Button
          size="small"
          onClick={async () => {
            try {
              const res = await axios.get("/api/debug-transactions");
              Swal.fire({
                title: "Debug Transaksi",
                html: `<pre>${JSON.stringify(res.data, null, 2)}</pre>`,
                width: 600,
              });
            } catch (err) {
              Swal.fire({
                icon: "error",
                title: "Gagal debug",
                text: err.response?.data?.message || err.message,
              });
            }
          }}
        >
          🔍 Cek Transaksi Langsung
        </Button>
      </div>

      {/* 📄 Konten Transaksi */}
      <div className="p-4">
        {loading ? (
          <div className="flex justify-center py-20">
            <Spin />
          </div>
        ) : !Array.isArray(transactions) ? (
          <p className="text-red-500">❌ Gagal menampilkan transaksi</p>
        ) : transactions.length === 0 ? (
          <Empty description="Belum ada transaksi" />
        ) : (
          <div className="grid grid-cols-1 gap-4">
            {transactions.map((tx) => (
              <TransactionCard
                key={tx.id}
                transaction={tx}
                onClick={() => handleOpenDrawer(tx)}
              />
            ))}
          </div>
        )}

        {/* 📄 Pagination */}
        {total > 25 && (
          <div className="mt-6 text-center">
            <Pagination
              current={currentPage}
              total={total}
              pageSize={25}
              onChange={(page) => fetchTransactions(page)}
            />
          </div>
        )}
      </div>

      {/* 📂 Drawer Detail Transaksi */}
      <TransactionDrawer
        transaction={isDrawerVisible ? selectedTransaction : null}
        visible={isDrawerVisible}
        onClose={() => setIsDrawerVisible(false)}
        onStatusUpdated={() => fetchTransactions(currentPage)}
      />
    </div>
  );
}
